"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.v3NodeNotLtsHelpLink = exports.v3NodeNotSupportedHelpLink = exports.v3NodeNotFoundHelpLink = exports.vxTestAppInstallHelpLink = exports.dotnetNotSupportTargetVersionHelpLink = exports.dotnetFailToInstallHelpLink = exports.dotnetExplanationHelpLink = exports.dotnetDefaultHelpLink = exports.nodeInstallationLink = exports.nodeNotFoundHelpLink = exports.functionDepsVersionsLink = exports.v3DefaultHelpLink = exports.defaultHelpLink = void 0;
// TODO: remove this link after clean the useless code.
exports.defaultHelpLink = "https://aka.ms/teamsfx-envchecker-help";
exports.v3DefaultHelpLink = "https://aka.ms/teamsfx-actions/devtool-install";
exports.functionDepsVersionsLink = "https://aka.ms/functions-node-versions";
// TODO: remove this link after clean the useless code.
exports.nodeNotFoundHelpLink = `https://aka.ms/teamsfx-node`;
exports.nodeInstallationLink = "https://nodejs.org/about/releases/";
exports.dotnetDefaultHelpLink = "https://aka.ms/teamsfx-actions/devtool-install";
exports.dotnetExplanationHelpLink = exports.dotnetDefaultHelpLink;
exports.dotnetFailToInstallHelpLink = exports.dotnetDefaultHelpLink;
// TODO: remove this link after clean the useless code.
exports.dotnetNotSupportTargetVersionHelpLink = `${exports.defaultHelpLink}#dotnetnotsupporttargetversion`;
exports.vxTestAppInstallHelpLink = `${exports.defaultHelpLink}#failtoinstallteamsvideoextensibilitytestapp`;
exports.v3NodeNotFoundHelpLink = "https://aka.ms/teamsfx-node";
exports.v3NodeNotSupportedHelpLink = "https://aka.ms/teamsfx-node";
exports.v3NodeNotLtsHelpLink = "https://aka.ms/teamsfx-node";
//# sourceMappingURL=helpLink.js.map